import {  client } from "../../../api/axiosConfig";

export const registerUser = (data) => {
    return client.post("/user/register", data);
};

//not currently in use
export const sendAdminWelcomeEmail = (data) => {
    return client.post("/send-admin-welcome-email", data);
};